var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHands(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.28 30.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main_icons",
    "data-name": "Main icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m.29,20.08l9.9,9.9c.39.39,1.02.39,1.41,0l4.95-4.95L5.24,13.71.29,18.66c-.39.39-.39,1.02,0,1.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.73,
    y: 8.54,
    width: 4,
    height: 16,
    transform: "translate(-7.68 14.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.9 8.06 15.14 12.3 17.97 9.47 16.56 8.06 10.9 8.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.21 19.37 22.21 13.71 20.8 12.3 17.97 15.13 22.21 19.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.58,7.35l1.41-1.41c.39-.39.39-1.02,0-1.41L25.76.29c-.39-.39-1.02-.39-1.41,0l-1.41,1.41c-.39.39-.39,1.02,0,1.41l.69.69-5.66,5.66,2.83,2.83,5.66-5.66.71.71c.39.39,1.02.39,1.41,0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands);
export default __webpack_public_path__ + "static/media/hands.d5d9dc60872fd8f26e5d2d3eb2feafd6.svg";
export { ForwardRef as ReactComponent };